/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useContext } from 'react';
import api from '../services/api';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { navigateBack, getCoursesPath } from '../utils/navigationHelper';

const CourseFormPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [file, setFile] = useState(null);
  const isEdit = Boolean(id);

  useEffect(() => {
    if (isEdit) {
      api.get(`/courses/${id}`)
        .then(res => {
          setTitle(res.data.title);
          setDescription(res.data.description);
        })
        .catch(console.error);
    }
  }, [id, isEdit]);

  const handleSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    if (file) formData.append('material', file);
    try {
      if (isEdit) {
        await api.put(`/courses/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      } else {
        await api.post('/courses', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      }
      // Navigate based on user role
      navigate(getCoursesPath(location, user));
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || 'Error saving course.');
    }
  };

  return (
    <div className="p-6 max-w-md">
      <button
        onClick={() => navigateBack(navigate, location, user, getCoursesPath(location, user))}
        className="text-blue-600 hover:text-blue-800 mb-4"
      >
        ← Back to Courses
      </button>
      <h1 className="text-2xl mb-4">{isEdit ? 'Edit' : 'New'} Course</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Title</label>
          <input
            className="w-full border p-2"
            value={title}
            onChange={e => setTitle(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block mb-1">Description</label>
          <textarea
            className="w-full border p-2"
            value={description}
            onChange={e => setDescription(e.target.value)}
          />
        </div>
        <div>
          <label className="block mb-1">Material (PDF)</label>
          <input
            type="file"
            accept=".pdf"
            onChange={e => setFile(e.target.files[0])}
          />
        </div>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          {isEdit ? 'Update' : 'Create'}
        </button>
      </form>
    </div>
  );
};

export default CourseFormPage;
